import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import PlaceholderImage from './PlaceholderImage';

const ImageCarousel = ({ images }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [startIndex, setStartIndex] = useState(0);

    if (!images || images.length === 0) {
        return (
            <div className="h-64 w-full rounded-lg shadow-md overflow-hidden">
                <PlaceholderImage />
            </div>
        );
    }

    return (
        <>
            <Carousel
                showThumbs={false}
                showStatus={false}
                infiniteLoop
                autoPlay
                interval={5000}
                dynamicHeight={false}
                className="rounded-lg shadow-md cursor-pointer"
                onClickItem={(index) => {
                    setStartIndex(index);
                    setModalOpen(true);
                }}
            >
                {images.map((img, idx) => (
                    <div key={idx}>
                        <img
                            src={img.url_imagen}
                            alt={`Imagen ${idx + 1}`}
                            className="object-cover h-64 w-full rounded-lg"
                        />
                    </div>
                ))}
            </Carousel>

            {/* Modal fullscreen con carrusel */}
            {modalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
                    <button
                        onClick={() => setModalOpen(false)}
                        className="absolute top-4 right-6 text-white text-3xl font-bold z-50 hover:text-red-400"
                    >
                        &times;
                    </button>

                    <div className="w-full max-w-6xl">
                        <Carousel
                            selectedItem={startIndex}
                            showThumbs={false}
                            showStatus={false}
                            infiniteLoop
                            useKeyboardArrows
                            className="max-h-[90vh]"
                        >
                            {images.map((img, idx) => (
                                <div key={idx}>
                                    <img
                                        src={img.url_imagen}
                                        alt={`Imagen grande ${idx + 1}`}
                                        className="object-contain max-h-[90vh] w-full rounded"
                                    />
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            )}
        </>
    );
};

export default ImageCarousel;
